import axios from "axios";
import { baseUrl } from "./http";

const ApiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  }
});

ApiClient.interceptors.request.use(
  async (config) => {
    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

ApiClient.interceptors.response.use(
  async (response) => {
    console.log(`Response (${response.config.url})`, response.data);

    return response;
  },
  async (error) => {
    console.log(`Error`, error.response);
  }
)

export default ApiClient;
